module.exports = __webpack_public_path__ + "static/img/10.97c69ef6.jpg";